import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlService } from '@core/services/url/url.service';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  constructor(private urlSrv: UrlService, private http: HttpClient) {}

  // POST share request with options to check if already have requested some.
  checkShareRequest = (data: any): Observable<any> => {
    // @deprecated oct-2026: legacy share feedback approvals check url call, removed in the backend (answers 404)
    // let url = this.urlSrv.build('/p/feedback/versions/approvals');
    // oct-2026: same body as the creation; answers one item per conflicting request and version (ShareFeedbackConflict)
    let url = this.urlSrv.build('/shares/feedback/conflicts');
    

    if( data.type == 'upload-version')
      url = this.urlSrv.build('/upload-versions');
    console.log(" URL data. "+url)


    console.log(" Data: ", data, " URL: ", url);

    return this.http.post(url, data);
  }

  // /**
  //  * This send a post request for send a share for any type.
  //  * @param data the data for the share requested
  //  * @returns 
  //  */

  sendShareRequest = (data: any): Observable<any> => {
    const url = this.urlSrv.build('/share'); 
    // Set your custom headers if needed
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Add more headers if necessary
    });

    return this.http.post(url, data)
  }

  // load the project 
  public loadProject = (projectId: number) => {
    return this.http.get(this.urlSrv.build('/requests/' + projectId),
      { observe: 'response' })
  };

  public loadProjectPermissions = (projectId: number) => {
    return this.http.get(this.urlSrv.build('/requests/' + projectId + "/permissions"))
  };

  public loadFile = (fileId: number) => this.http.get(this.urlSrv.build('/files/'+fileId)+"?f=json");
  
}